<!-- 库存商品列表_添加网销商品 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" style="width: 120px" size="small" v-model.trim="searchData.apCode" placeholder="汽配编码"></el-input>
                <div class="search-name">互换码</div>
                <el-input class="search-item" style="width: 120px" size="small" v-model.trim="searchData.goodsCode" placeholder="互换码"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" style="width: 120px" size="small" v-model.trim="searchData.goodsName" placeholder="请输入汽配名称"></el-input>
                <div class="search-name">适用车型</div>
                <el-input class="search-item" style="width: 120px" size="small" v-model.trim="searchData.autoSerise" placeholder="适用车型"></el-input>
                <div class="search-name">品牌</div>
                <div class="search-item" style="width: 100px">
                    <el-select v-model.trim="searchData.brandName" filterable clearable size="small" @visible-change="brandVisibleChange($event)">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="optionItem in brandList" :key="optionItem.Text" :label="optionItem.Text" :value="optionItem.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">分类</div>
                <div class="search-item" style="width: 100px">
                    <el-select
                        size="small"
                        v-model="searchData.cate"
                        filterable
                        clearable
                        remote
                        @visible-change="cateVisibleChange($event)"
                        v-select-scroll-more="searchCateLoad"
                        :remote-method="searchCateList"
                        popper-class="my-select"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                        <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                    </el-select>
                </div>
                <div class="search-name">图片</div>
                <div class="search-item" style="width: 80px">
                    <el-select v-model="searchData.existImg" size="small">
                        <el-option label="不限" value="-1"></el-option>
                        <el-option label="有图" value="1"></el-option>
                        <el-option label="无图" value="0"></el-option>
                    </el-select>
                </div>
                <div class="search-name">
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn" type="primary" v-if="permission.batchAdd" @click="batchAdd">
                        {{ permission.batchAdd }} {{ multipleSelection.length > 0 ? '(' + multipleSelection.length + ') 项' : '' }}</el-button
                    >
                    <el-button v-if="isVip" size="small" type="danger" class="search-btn" @click="batchAddBySearch">按搜索条件上网销</el-button>
                    <span style="color: red" v-if="!isVip">
                        {{ permission.batchAdd ? ' （有主/辅图，库存大于零，零售价大于零的商品才可' + permission.batchAdd + '）' : '' }}</span
                    >
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="unsharedGoodsList" @selection-change="handleSelectionChange" border="" style="width: 100%">
                <el-table-column
                    type="selection"
                    :selectable="
                        (row, index) => {
                            return isVip ? true : (row.MainImg || row.ExistAsdImg) && row.MarketPrice > 0 && row.Inventory > 0 ? true : false;
                        }
                    "
                ></el-table-column>
                <el-table-column width="200px" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column width="200px" prop="GoodsCode" label="互换码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="GoodsName" label="汽配名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Inventory" label="库存" show-overflow-tooltip></el-table-column>
                <el-table-column prop="CostPrice" label="成本价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="MarketPrice" label="零售价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Price" label="批发价" show-overflow-tooltip></el-table-column>
                <el-table-column prop="MainImg" label="主图" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.MainImg ? '有' : '无' }}
                    </template>
                </el-table-column>
                <el-table-column prop="ExistAsdImg" label="辅图" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.ExistAsdImg ? '有' : '无' }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="90px">
                    <template slot-scope="scope">
                        <el-button :value="scope.row.GoodsId" @click="edit(scope.row.GoodsId)" type="text" v-if="permission.shared">{{ permission.shared }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="unsharedGoodsListCount"
                ></el-pagination>
            </div>
            <template>
                <EditSIGoods @closeDialogForm="closeDialogForm" :propsGoodsId="goodsId" :dialogFormVisible="dialogFormVisible" :action="action"></EditSIGoods>
            </template>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import EditSIGoods from '@/views/business/shareInventory/editSIGoods';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        EditSIGoods,
        breadcrumb
    },
    data() {
        return {
            dialogFormVisible: false,
            goodsId: '',
            action: '',
            loading: false,
            searchData: {
                apCode: '',
                goodsCode: '',
                goodsName: '',
                autoSerise: '',
                brandName: '',
                cate: '',
                shelfSpaceId: '',
                existImg: '-1',
                page: 1,
                limit: 15
            },
            unsharedGoodsList: null,
            unsharedGoodsListCount: 0,
            brandList: [],
            apCategoryList: [],
            permission: {},
            multipleSelection: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            isVip: false
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('MyShareGoods');
        this.getUnsharedGoodsList();
        this.getConfigByCodes();
    },
    computed: {},
    watch: {},
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['vipcuswxbxsh'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'vipcuswxbxsh':
                                    this.isVip = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        //获取未网销的库存商品
        getUnsharedGoodsList() {
            this.$util
                .axiosGet({
                    url: '/api/ShareInventory/GetUnsharedGoodsList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.unsharedGoodsList = res.data;
                        this.unsharedGoodsListCount = res.count;
                    } else {
                        this.unsharedGoodsList = [];
                        this.unsharedGoodsListCount = 0;
                    }
                })
                .catch(err => {});
        },
        //获取品牌分类
        getEnterprisePartBrandList() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(err => {});
        },
        //获取汽配分类
        searchCateList(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.loading = true;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (data) {
                        this.loading = false;
                        if (!data) return;
                        this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                        this.codeList = this.$util.uniqueArr(this.apCategoryList, data);
                    }
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCateList();
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.getEnterprisePartBrandList();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCateList('');
            }
        },
        edit(gid) {
            this.goodsId = gid;
            this.dialogFormVisible = true;
            this.action = 'add';
        },
        //关闭dialog
        //data={goodsId,action}
        //action:close,直接关闭，addsuccess添加成功，找到对应的商品并将其从列表中移除
        closeDialogForm(data) {
            let that = this;
            if (data && data.action == 'addsuccess' && data.goodsId) {
                let goodslist = that.unsharedGoodsList;
                for (let i = 0; i < goodslist.length; i++) {
                    if (goodslist[i].GoodsId == data.goodsId) {
                        that.unsharedGoodsList.splice(i, 1);
                        that.unsharedGoodsListCount = that.unsharedGoodsListCount - 1;
                        this.dialogFormVisible = false;
                        return;
                    }
                }
            }
            this.dialogFormVisible = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getUnsharedGoodsList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getUnsharedGoodsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getUnsharedGoodsList();
        },
        resetSearch() {
            this.searchData = {
                apCode: '',
                goodsCode: '',
                goodsName: '',
                autoSerise: '',
                brandName: '',
                cate: '',
                shelfSpaceId: '',
                existImg: '-1',
                page: 1,
                limit: this.commonPageSize
            };
        },
        batchAdd() {
            let that = this;
            if (that.multipleSelection.length == 0) {
                that.$util.warningMsg('请选择商品');
                return;
            }
            let idList = [];
            for (let i = 0; i < that.multipleSelection.length; i++) {
                idList.push(that.multipleSelection[i].GoodsId);
            }
            that.$confirm('确定将这些商品上网销吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: '/api/ShareInventory/BatchShare',
                        data: {
                            GoodsIds: idList
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('保存成功！');
                            that.getUnsharedGoodsList();
                        }
                    });
            });
        },
        batchAddBySearch() {
            let that = this;
            if (that.unsharedGoodsList.length == 0) {
                that.$util.warningMsg('请搜索商品');
                return;
            }

            if (!that.searchData.apCode && !that.searchData.goodsCode && !that.searchData.goodsName && !that.searchData.autoSerise && !that.searchData.brandName && !that.searchData.cate && that.searchData.existImg == '-1') {
                that.$util.warningMsg('请搜索商品'); 
                return;
            }

            that.$confirm('确定将这些商品上网销吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosGet({
                        url: '/api/ShareInventory/BatchShareForSearch',
                        data: that.searchData
                    })
                    .then(res => {
                        console.log(res);
                        if (res.data) {
                            if (res.data > 0) {
                                that.$util.successMsg(res.data + '个商品已上网销');
                                that.getUnsharedGoodsList();
                            } else {
                                that.$util.errorMsg('未检测到要上网销的商品');
                            }
                        }
                    })
                    .catch(err => {});
            });
        }
    }
};
</script>
